var size = {"size_1":"Medium", "size_2": "Firm"};

var product_images = {
  "child": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/kids_non_1.png?v=1719063902",
  "two_person_300": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/M_1.png?v=1719064125",
  "single_person_300": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/M.png?v=1719064123",
  "two_single_person_300": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/Two_single_M-300.png?v=1719064311",
  "single_person_100": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/M.png?v=1719064123",
  "two_person_100": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/M_1.png?v=1719064125",
  "two_single_person_100": "https://cdn.shopify.com/s/files/1/0792/0815/3417/files/Two_single_M-300.png?v=1719064311"
};

// Dubbele matrasgroottes die ook beschikbaar zijn voor 1 persoon
var doubleSizesForSingle = ['160x200', '160x210', '160x220', '180x200', '180x210', '180x220', '200x200', '200x210', '200x220'];

// AANGEPASTE FUNCTIE: Verbeterde variant ID ophaal met meer fallback opties
function getVariantId(productSelector, title) {
  console.log(`Zoeken naar variant met title: "${title}" in product: "${productSelector}"`);
  
  // Voor 2-persoons matrassen: probeer verschillende formaten
  var alternativeTitles = [title];
  
  // Als het een 2-persoons matras is met hardheden
  if (title.includes(' / ') && (title.match(/\//g) || []).length === 2) {
    // Parse de titel
    var parts = title.split(' / ');
    if (parts.length === 3) {
      var size = parts[0];
      var firmness1 = parts[1];
      var firmness2 = parts[2];
      
      // Probeer met dash in plaats van slash voor hardheden
      alternativeTitles.push(`${size} / ${firmness1} - ${firmness2}`);
      // Probeer zonder spaties rond dash
      alternativeTitles.push(`${size} / ${firmness1}-${firmness2}`);
      // Probeer volledig andere formats
      alternativeTitles.push(`${size} / ${firmness1}/${firmness2}`);
      
      // BELANGRIJK: Als de hardheden verschillend zijn, probeer ook omgekeerde volgorde
      if (firmness1 !== firmness2) {
        alternativeTitles.push(`${size} / ${firmness2} - ${firmness1}`);
        alternativeTitles.push(`${size} / ${firmness2}-${firmness1}`);
        alternativeTitles.push(`${size} / ${firmness2}/${firmness1}`);
      }
    }
  }
  
  // Probeer alle mogelijke titelvarianten
  for (var i = 0; i < alternativeTitles.length; i++) {
    var tryTitle = alternativeTitles[i];
    console.log(`Probeer variant: "${tryTitle}"`);
    
    // Methode 1: Exacte match met data-title attribuut
    var exactMatch = $(`${productSelector} .product_variants [data-title="${tryTitle}"]`);
    if (exactMatch.length > 0 && exactMatch.attr('value')) {
      console.log(`Match gevonden met: "${tryTitle}" - ID: ${exactMatch.attr('value')}`);
      return exactMatch.attr('value');
    }
    
    // Methode 2: Zoek in option elements met data-title
    var optionMatch = $(`${productSelector} .product_variants option[data-title="${tryTitle}"]`);
    if (optionMatch.length > 0 && optionMatch.attr('value')) {
      console.log(`Option match gevonden met: "${tryTitle}" - ID: ${optionMatch.attr('value')}`);
      return optionMatch.attr('value');
    }
  }
  
  // Debug: log alle beschikbare opties
  console.log(`Geen match gevonden voor "${title}". Beschikbare opties:`);
  $(`${productSelector} .product_variants option`).each(function() {
    var optionTitle = $(this).data('title') || $(this).text();
    var optionValue = $(this).attr('value') || $(this).val();
    console.log(`- Title: "${optionTitle}", Value: "${optionValue}"`);
  });
  
  // Return undefined om terug te vallen op originele gedrag
  return undefined;
}

// AANGEPASTE FUNCTIE: Fallback naar originele gedrag als nieuwe functie faalt
function getVariantPrice(productSelector, variantId, isPriceForTwo = false) {
  if (!variantId) return '';
  
  var priceDataKey = isPriceForTwo ? 'price2' : 'price';
  
  // Probeer eerst de nieuwe methode
  var price = $(`${productSelector} .product_variants [value="${variantId}"]`).data(priceDataKey);
  
  if (!price) {
    // Fallback naar originele methode
    price = $(`${productSelector} .product_variants [value="${variantId}"]`).data(isPriceForTwo ? 'price2' : 'price');
  }
  
  return price || '';
}

// AANGEPASTE FUNCTIE: Minder strenge validatie, meer compatibel met origineel
function setProductData(productSelector, variantId, title, price, quantity = 1) {
  console.log(`Setting product data voor ${productSelector}: ID=${variantId}, Title=${title}, Price=${price}, Qty=${quantity}`);
  
  // Als er geen ID is, log het maar ga door (originele gedrag)
  if (!variantId) {
    console.warn(`Geen variant ID gevonden voor product ${productSelector}, maar ga door met originele logica`);
  }
  
  // Normaliseer de titel voor 2-persoons matrassen (zet Medium altijd eerst)
  var displayTitle = title;
  if (title.includes(' / ') && (title.includes(' - ') || title.includes('-'))) {
    var parts = title.split(' / ');
    if (parts.length === 2) {
      var sizePart = parts[0];
      var firmnessPart = parts[1];
      
      // Check of het hardheden bevat
      if (firmnessPart.includes('Medium') || firmnessPart.includes('Firm')) {
        var firmnesses = firmnessPart.split(/\s*-\s*/); // Split op dash met of zonder spaties
        if (firmnesses.length === 2) {
          // Sorteer zodat Medium voor Firm komt
          var sortedFirmness = firmnesses.sort(function(a, b) {
            if (a === "Medium" && b === "Firm") return -1;
            if (a === "Firm" && b === "Medium") return 1;
            return 0;
          });
          displayTitle = `${sizePart} / ${sortedFirmness[0]} - ${sortedFirmness[1]}`;
        }
      }
    }
  }
  
  // Stel alle benodigde velden in met de genormaliseerde titel
  $(`${productSelector} .product_variants`).val(variantId);
  $(`${productSelector} .prod_subtitle`).text(displayTitle);
  $(`${productSelector} .quiz_prod_price`).text(price);
  $(`${productSelector} .quiz_prod_btns [name="id"]`).val(variantId);
  $(`${productSelector} .quiz_prod_btns .quantity`).val(quantity);
  
  return true; // Altijd true om flow door te laten gaan
}

// NIEUWE HELPER FUNCTIE: Format de titel correct voor 2-persoons matrassen
function formatTwoPersonTitle(mattressSize, firmness1, firmness2) {
  // Sorteer de hardheden zodat Medium altijd eerst komt
  var sortedFirmness = [firmness1, firmness2].sort(function(a, b) {
    // Medium komt voor Firm
    if (a === "Medium" && b === "Firm") return -1;
    if (a === "Firm" && b === "Medium") return 1;
    return 0;
  });
  
  // Return met dash format, Medium altijd eerst
  return `${mattressSize} / ${sortedFirmness[0]} - ${sortedFirmness[1]}`;
}

function addQueryString() {
  var currentUrl = window.location.href;
  if (!currentUrl.includes('?results')) {
    var separator = currentUrl.includes('?') ? '&' : '?';
    var newUrl = currentUrl + separator + 'results';
    window.history.replaceState({}, '', newUrl);
  }
}

function removeQueryString() {
  var currentUrl = window.location.href;
  if (currentUrl.includes('?results')) {
    var newUrl = currentUrl.replace('?results', '');
    newUrl = newUrl.replace(/[\?&]$/, '');
    window.history.replaceState({}, '', newUrl);
  }
}

function saveCheckedInputs() {
  var checkedInputs = {};
  $('.multistepForm_section input:checked').each(function() {
    var inputName = $(this).attr('name');
    var inputValue = $(this).val();
    checkedInputs[inputName] = inputValue;
  });
  var checkedInputsJson = JSON.stringify(checkedInputs);
  localStorage.setItem('multiStepFormData', checkedInputsJson);
}

function loadAndSetInputs() {
  var savedData = localStorage.getItem('multiStepFormData');
  if (savedData) {
    var parsedData = JSON.parse(savedData);
    console.log('Loaded data:', parsedData);
    for (var key in parsedData) {
      if (parsedData.hasOwnProperty(key)) {
        $('.multistepForm_section input[name="' + key + '"][value="' + parsedData[key] + '"]').prop('checked', true);
      }
    }
  } else {
    console.log('No data found in local storage.');
  }
}

function checkQueryString() {
  var currentUrl = window.location.href;
  if (currentUrl.includes('?results')) {
    loadAndSetInputs();
    $('.quiz_result_main').show();
    $('.multistepForm_section').addClass('hide');
    var persons = $('[name="persons"]:checked').data('value');
    $('.quiz_prod_wrap').hide();

    if (persons === 'person-3') {
      // EENVOUDIGE AANPAK: Kindermatras direct afhandelen
      var product = '.kindermatras';
      var childSize = $('[name="child_size"]:checked').val().replace(/\n/g, '').trim();
      
      console.log(`Zoeken naar kindermatras met maat: "${childSize}"`);
      
      var selectElement = $(`${product} .product_variants`);
      var matchedOption = selectElement.find(`option:contains("${childSize}")`).first();
      
      if (matchedOption.length > 0) {
        var variantId = matchedOption.attr('value');
        var price = matchedOption.data('price');
        
        selectElement.val(variantId);
        $(`${product} .prod_subtitle`).text(childSize);
        $(`${product} .quiz_prod_price`).text(price);
        $(`${product} .quiz_prod_btns [name="id"]`).val(variantId);
        $(`${product} .quiz_prod_btns .quantity`).val(1);
        $(`${product} .quiz_prod_header img`).attr('src', product_images['child']);
        
        setTimeout(function() { $(product).show(); }, 300);
      } else {
        console.error(`Geen kindermatras variant gevonden voor maat: ${childSize}`);
      }

    } else if (persons === 'person-1') {
      var product1 = '.ubed-m-300-enkel';
      var product2 = '.ubed-m-100-enkel';
      var mattress_size_person1 = $('[name="mattress_size_person1"]:checked').val().replace(/\n/g, '');
      var firmness_suits_person1 = $('[name="firmness_suits_person1"]:checked').val().replace(/\n/g, '');
      var firmness_suits = size[firmness_suits_person1];
      var qty = 1;
      var title, id1, id2, price1, price2;

      // Check if it's a double size for single person
      if (doubleSizesForSingle.includes(mattress_size_person1)) {
        // Use double mattress products for large sizes
        product1 = '.ubed-m-300-dubbel';
        product2 = '.ubed-m-100-dubbel';
        
        // Create double firmness title with dash format
        title = formatTwoPersonTitle(mattress_size_person1, firmness_suits, firmness_suits);
        
        // Gebruik nieuwe functie met fallback naar origineel
        id1 = getVariantId(product1, title) || $(`${product1} .product_variants [data-title="${title}"]`).attr('value');
        id2 = getVariantId(product2, title) || $(`${product2} .product_variants [data-title="${title}"]`).attr('value');
        price1 = getVariantPrice(product1, id1) || $(`${product1} .product_variants [value="${id1}"]`).data('price');
        price2 = getVariantPrice(product2, id2) || $(`${product2} .product_variants [value="${id2}"]`).data('price');
        
        $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_person_300']);
        $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_person_100']);
      } else {
        // Handle smaller sizes that need to be split into two singles
        if (mattress_size_person1 === '160x200') {
          qty = 2;
          mattress_size_person1 = '80x200';
        } else if (mattress_size_person1 == '160x210') {
          qty = 2;
          mattress_size_person1 = '80x210';
        } else if (mattress_size_person1 == '160x220') {
          qty = 2;
          mattress_size_person1 = '80x220';
        } else if (mattress_size_person1 == '180x200') {
          qty = 2;
          mattress_size_person1 = '90x200';
        } else if (mattress_size_person1 == '180x210') {
          qty = 2;
          mattress_size_person1 = '90x210';
        } else if (mattress_size_person1 == '180x220') {
          qty = 2;
          mattress_size_person1 = '90x220';
        }

        title = `${mattress_size_person1} / ${firmness_suits}`;
        id1 = getVariantId(product1, title) || $(`${product1} .product_variants [data-title="${title}"]`).attr('value');
        id2 = getVariantId(product2, title) || $(`${product2} .product_variants [data-title="${title}"]`).attr('value');

        if (qty === 2) {
          price1 = getVariantPrice(product1, id1, true) || $(`${product1} .product_variants [value="${id1}"]`).data('price2');
          price2 = getVariantPrice(product2, id2, true) || $(`${product2} .product_variants [value="${id2}"]`).data('price2');
          $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_single_person_300']);
          $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_single_person_100']);
        } else {
          price1 = getVariantPrice(product1, id1) || $(`${product1} .product_variants [value="${id1}"]`).data('price');
          price2 = getVariantPrice(product2, id2) || $(`${product2} .product_variants [value="${id2}"]`).data('price');
          $(`${product1} .quiz_prod_header img`).attr('src', product_images['single_person_300']);
          $(`${product2} .quiz_prod_header img`).attr('src', product_images['single_person_100']);
        }
      }

      // Gebruik setProductData zonder blokkerende if-statements
      setProductData(product1, id1, title, price1, qty);
      setProductData(product2, id2, title, price2, qty);

      setTimeout(function() {
        $(product1).show();
        $(product2).show();
      }, 300);

    } else if (persons === 'person-2') {
      var mattress_size_person2 = $('[name="mattress_size_person2"]:checked').val().replace(/\n/g, '');
      if (mattress_size_person2.includes('2x ')) {
        var product1 = '.ubed-m-300-enkel';
        var product2 = '.ubed-m-100-enkel';
        mattress_size_person2 = mattress_size_person2.replace('2x ', '');
        var qty = 2; // BELANGRIJK: altijd 2 stuks bij 2x enkele matrassen
      } else {
        var product1 = '.ubed-m-300-dubbel';
        var product2 = '.ubed-m-100-dubbel';
        var qty = 1;
      }

      var firmness_suits1_person2 = $('[name="firmness_suits1_person2"]:checked').val().replace(/\n/g, '');
      var firmness_suits2_person2 = $('[name="firmness_suits2_person2"]:checked').val().replace(/\n/g, '');
      var firmness_suits1 = size[firmness_suits1_person2];
      var firmness_suits2 = size[firmness_suits2_person2];
      
      // BELANGRIJK: Gebruik de nieuwe format functie voor 2-persoons matrassen
      var title = formatTwoPersonTitle(mattress_size_person2, firmness_suits1, firmness_suits2);

      var id1, id2, price1, price2;

      if (qty === 2) {
        // Voor 2x enkele matrassen - ALTIJD 2 stuks toevoegen
        if (firmness_suits1 === firmness_suits2) {
          // Beide personen hebben dezelfde hardheid
          var titleMulti = `${mattress_size_person2} / ${firmness_suits1}`;
          id1 = getVariantId(product1, titleMulti);
          id2 = getVariantId(product2, titleMulti);
          price1 = getVariantPrice(product1, id1, true); // Gebruik price2 voor dubbele prijs
          price2 = getVariantPrice(product2, id2, true);
          
          // Voeg 2 identieke matrassen toe
          setProductData(product1, id1, `${titleMulti} (2 stuks)`, price1, 2);
          setProductData(product2, id2, `${titleMulti} (2 stuks)`, price2, 2);
          
        } else {
          // Verschillende hardheden - toon instructie voor handmatig toevoegen
          var titlePerson1 = `${mattress_size_person2} / ${firmness_suits1}`;
          var titlePerson2 = `${mattress_size_person2} / ${firmness_suits2}`;
          
          // Haal beide varianten op
          id1 = getVariantId(product1, titlePerson1);
          id2 = getVariantId(product2, titlePerson1);
          price1 = getVariantPrice(product1, id1);
          price2 = getVariantPrice(product2, id2);
          
          // Stel eerste variant in (Persoon 1)
          setProductData(product1, id1, titlePerson1, price1, 1);
          setProductData(product2, id2, titlePerson1, price2, 1);
          
          // Voeg instructie toe voor gebruiker
          $(`${product1} .prod_subtitle`).html(`
            <strong>${mattress_size_person2}</strong><br>
            <span style="color: #19747e;">✓ Persoon 1: ${firmness_suits1}</span><br>
            <span style="color: #19747e;">✓ Persoon 2: ${firmness_suits2}</span><br>
            <em style="color: #e74c3c; font-weight: bold;">Let op: Voeg dit product 2x toe:</em><br>
            <small>1. Eerst met ${firmness_suits1}<br>
            2. Dan wijzigen naar ${firmness_suits2} en nogmaals toevoegen</small>
          `);
          $(`${product2} .prod_subtitle`).html(`
            <strong>${mattress_size_person2}</strong><br>
            <span style="color: #19747e;">✓ Persoon 1: ${firmness_suits1}</span><br>
            <span style="color: #19747e;">✓ Persoon 2: ${firmness_suits2}</span><br>
            <em style="color: #e74c3c; font-weight: bold;">Let op: Voeg dit product 2x toe:</em><br>
            <small>1. Eerst met ${firmness_suits1}<br>
            2. Dan wijzigen naar ${firmness_suits2} en nogmaals toevoegen</small>
          `);
        }
        
        $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_single_person_300']);
        $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_single_person_100']);
      } else {
        // Voor dubbel matras (met verschillende hardheden per kant)
        id1 = getVariantId(product1, title);
        id2 = getVariantId(product2, title);
        price1 = getVariantPrice(product1, id1);
        price2 = getVariantPrice(product2, id2);
        
        setProductData(product1, id1, title, price1, 1);
        setProductData(product2, id2, title, price2, 1);
        
        $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_person_300']);
        $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_person_100']);
      }

      setTimeout(function() {
        $(product1).show();
        $(product2).show();
      }, 300);
    }
  }
}

checkQueryString();

// Zet Next-knop standaard disabled bij laden
$('.next-step').addClass('disabled');

var validSizes = ['180x200', '180x210', '180x220'];

// DEFINITIEVE WERKENDE VERSIE
function initializeFirmnessCalculator() {
  console.log('=== START CALCULATOR INIT ===');
  
  var activeStep = $('.MsForm_step.active');
  var calculatorInStep = activeStep.find('#firmness-calculator');
  
  console.log('Actieve stap:', activeStep.data('step'));
  console.log('Calculator in actieve stap:', calculatorInStep.length);
  
  if (calculatorInStep.length === 0) {
    console.log('⏭️ Geen calculator in deze stap, skip');
    return;
  }
  
  var calculator = calculatorInStep[0];
  console.log('✅ Calculator gevonden!');
  
  var firmnessParameters = {
    "back":  [26.5],
    "belly": [26.5],
    "side":  [28.0],
    "":      [27.5]
  };

  // Check elementen - GEBRUIK DE ORIGINELE IDs
  var toggleBtn = calculator.querySelector('.toggle-button');
  var btn = calculator.querySelector('#fc-calc'); // ORIGINEEL ID
  var resultEl = calculator.querySelector('#fc-result'); // ORIGINEEL ID
  
  if (!toggleBtn || !btn || !resultEl) {
    console.error('❌ Elementen niet gevonden');
    console.log('Toggle:', !!toggleBtn, 'Button:', !!btn, 'Result:', !!resultEl);
    return;
  }

  console.log('✅ Alle elementen gevonden, listeners toevoegen...');
  
  // Clone om oude listeners te verwijderen
  var newToggleBtn = toggleBtn.cloneNode(true);
  toggleBtn.parentNode.replaceChild(newToggleBtn, toggleBtn);
  toggleBtn = newToggleBtn;
  var toggleIcon = toggleBtn.querySelector('.toggle-icon');
  
  var newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);
  btn = newBtn;

  // Toggle functionaliteit
  toggleBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('🔵 TOGGLE CLICKED!');
    calculator.classList.toggle('expanded');
    toggleIcon.textContent = calculator.classList.contains('expanded') ? '−' : '+';
    console.log('Expanded:', calculator.classList.contains('expanded'));
  });

  // Calculator functionaliteit
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('🟢 CALC BUTTON CLICKED!');
    
    // GEBRUIK ORIGINELE IDs
    var heightInput = calculator.querySelector('#fc-height');
    var weightInput = calculator.querySelector('#fc-weight');
    var positionInput = calculator.querySelector('#fc-position');
    
    if (!heightInput || !weightInput || !positionInput) {
      console.error('❌ Inputs niet gevonden!');
      return;
    }
    
    var h = parseFloat(heightInput.value);
    var w = parseFloat(weightInput.value);
    var p = positionInput.value;

    console.log('Values:', h, w, p);

    if (isNaN(h) || isNaN(w) || h <= 0 || w <= 0 || !heightInput.value || !weightInput.value) {
      console.log('⚠️ Validatie gefaald');
      resultEl.querySelector('.label').textContent = '';
      resultEl.querySelector('.result-value').textContent = 'Vul a.u.b. zowel lengte als gewicht in.';
      resultEl.querySelector('.result-value').style.color = '#e74c3c';
      resultEl.querySelector('.result-value').style.fontSize = '14px';
      resultEl.classList.add('error', 'show-result');
      setTimeout(function() {
        resultEl.classList.remove('error');
        resultEl.querySelector('.result-value').style.color = '';
        resultEl.querySelector('.result-value').style.fontSize = '';
      }, 3000);
      return;
    }

    var heightInMeters = h / 100;
    var bmi = w / (heightInMeters * heightInMeters);
    var target = (firmnessParameters[p] || firmnessParameters[''])[0];
    var advice = (bmi < target) ? 'Medium' : 'Firm';

    console.log('✅ Berekening: BMI:', bmi, 'Advies:', advice);

    resultEl.querySelector('.result-value').style.color = '';
    resultEl.querySelector('.result-value').style.fontSize = '';
    
    resultEl.classList.remove('error');
    resultEl.classList.add('calculating', 'show-result');
    
    setTimeout(function() {
      resultEl.classList.remove('calculating');
      resultEl.querySelector('.label').textContent = 'Aanbevolen hardheid:';
      resultEl.querySelector('.result-value').textContent = advice;
    }, 600);
  });

  // Tooltip functionaliteit
  var tooltipWrappers = calculator.querySelectorAll('.tooltip');
  tooltipWrappers.forEach(function(wrapper) {
    var newWrapper = wrapper.cloneNode(true);
    wrapper.parentNode.replaceChild(newWrapper, wrapper);
    
    newWrapper.addEventListener('click', function(e) {
      e.stopPropagation();
      newWrapper.classList.toggle('open');
    });
  });
  
  tooltipWrappers = calculator.querySelectorAll('.tooltip');
  
  document.addEventListener('click', function(e) {
    if (!calculator.contains(e.target)) {
      tooltipWrappers.forEach(function(wrapper) {
        wrapper.classList.remove('open');
      });
    }
  });

  // Input focus effects
  var inputs = calculator.querySelectorAll('input, select');
  console.log('Inputs gevonden:', inputs.length);
  
  inputs.forEach(function(input) {
    var newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);
    
    newInput.addEventListener('focus', function() {
      var wrapper = this.closest('.input-wrapper') || this.closest('.select-wrapper');
      if (wrapper) wrapper.classList.add('focused');
    });
    newInput.addEventListener('blur', function() {
      var wrapper = this.closest('.input-wrapper') || this.closest('.select-wrapper');
      if (wrapper) wrapper.classList.remove('focused');
    });
  });
  
  console.log('✅ Calculator volledig geïnitialiseerd!');
  console.log('=== EINDE INIT ===');
}

$(document).ready(function() {
  // Probeer direct bij laden
  setTimeout(initializeFirmnessCalculator, 100);
  
  // "Next" klik: alleen als niet disabled
  $('.next-step').click(function() {
    if ($(this).hasClass('disabled')) return;

    var step = $('.MsForm_step.active').data('step') * 1;
    var nextStep = step + 1;
    var persons = $('[name="persons"]:checked').data('value');
    var personsValue = $('[name="persons"]:checked').val();
    var maxStep = 5;
    if (persons === 'person-3') maxStep = 3;
    $('.maxCount').text(maxStep - 1);

    if (nextStep <= maxStep && nextStep > 0) {
      if (persons === 'person-1' && nextStep === 4) {
        var mattress_size_person1 = $('[name="mattress_size_person1"]:checked').val().replace(/\n/g, '');
        if (validSizes.includes(mattress_size_person1)) {
          $('.step-options4').show();
        } else {
          $('.step-options4').hide();
          $('.step-options4 input').prop('checked', false);
        }
      }

      removeQueryString();
      var bg = `conic-gradient(#111111 ${(nextStep / maxStep) * 360}deg, #d3d3d3 ${(nextStep / maxStep) * 360}deg 360deg)`;
      $('.MsProgress').css("background", bg);
      $('.MsProgress--value.not-success-text').text(`0${nextStep}`);
      $('.MsProgress--title .count').text(nextStep);
      var totalSteps = $('.MsForm_step').length;
      var percent = (nextStep / totalSteps) * 100;
      $('.custom-progress-bar').css('width', percent + '%');

      $('.MsForm_step.active').removeClass('active');
      $(`.MsForm_step[data-step="${nextStep}"]`).addClass('active');

      // BELANGRIJK: Initialiseer calculator na stap wisseling
      setTimeout(initializeFirmnessCalculator, 200);

      if (nextStep === 2) {
        $('.prev-step').show();
        $('.content-person').hide();
        $(`.content-${persons}`).show();
      }

      if (nextStep === maxStep) {
        $('.MsFormHeader_progress').addClass('success');
        var btn_text = $('.next-step').data('success');
        $('.next-step').text(btn_text);
      } else {
        $('.MsFormHeader_progress').removeClass('success');
        var btn_text = $('.next-step').data('next');
        $('.next-step').text(btn_text);
      }

      // Na navigatie: Next weer op disabled
      $('.next-step').addClass('disabled');

      if (nextStep === maxStep && persons === 'person-3') {
        var child_size = $('[name="child_size"]:checked').val() || '';
        var items = [personsValue, child_size].filter(function(v) { return v && v.trim() !== ''; });
        var htmlLis = items.map(function(v) { return '<li>' + v + '</li>'; }).join('');
        $('.selected-options ul').html(htmlLis);
        $('.next-step').removeClass('disabled');

      } else if (nextStep === maxStep && persons === 'person-2') {
        var mattress_size_person2    = $('[name="mattress_size_person2"]:checked').val()       || '';
        var firmness_suits1_person2 = $('[name="firmness_suits1_person2"]:checked').val()      || '';
        var firmness_suits2_person2 = $('[name="firmness_suits2_person2"]:checked').val()      || '';
        var temperature1_person2    = $('[name="temperature1_person2"]:checked').val()         || '';
        var temperature2_person2    = $('[name="temperature2_person2"]:checked').val()         || '';
        var struggles = '';
        $('[name="struggle1_person2"]:checked').each(function() { struggles += $(this).val() + ', '; });
        $('[name="struggle2_person2"]:checked').each(function() { struggles += $(this).val() + ', '; });
        struggles = struggles.replace(/, $/, '');

        var fs1 = size[firmness_suits1_person2] || '';
        var fs2 = size[firmness_suits2_person2] || '';

        var items2 = [
          personsValue,
          mattress_size_person2,
          fs1,
          fs2,
          temperature1_person2,
          temperature2_person2,
          struggles
        ].filter(function(v) { return v && v.trim() !== ''; });

        var htmlLis2 = items2.map(function(v) { return '<li>' + v + '</li>'; }).join('');
        $('.selected-options ul').html(htmlLis2);
        $('.next-step').removeClass('disabled');

      } else if (nextStep === maxStep && persons === 'person-1') {
        var mattress_size_person1  = $('[name="mattress_size_person1"]:checked').val()    || '';
        var firmness_suits_person1 = $('[name="firmness_suits_person1"]:checked').val() || '';
        var temperature_person1    = $('[name="temperature_person1"]:checked').val()    || '';
        var struggles1 = '';
        $('[name="struggle1_person"]:checked').each(function() { struggles1 += $(this).val() + ', '; });
        struggles1 = struggles1.replace(/, $/, '');

        var fs1_1 = size[firmness_suits_person1] || '';

        var items1 = [
          personsValue,
          mattress_size_person1,
          fs1_1,
          temperature_person1,
          struggles1
        ].filter(function(v) { return v && v.trim() !== ''; });

        var htmlLis1 = items1.map(function(v) { return '<li>' + v + '</li>'; }).join('');
        $('.selected-options ul').html(htmlLis1);
        $('.next-step').removeClass('disabled');
      }

    } else if (nextStep > maxStep) {
      // Voeg query string toe voor resultaten
      addQueryString();
      
      $('.quiz_result_main').show();
      $('.multistepForm_section').addClass('hide');
      $('.quiz_prod_wrap').hide();

      if (persons === 'person-3') {
        var product = '.kindermatras';
        var title = $('[name="child_size"]:checked').val().replace(/\n/g, '');
        var id = getVariantId(product, title);
        var price = getVariantPrice(product, id);
        
        if (setProductData(product, id, title, price, 1)) {
          $(`${product} .quiz_prod_header img`).attr('src', product_images['child']);
          setTimeout(function() {
            $(product).show();
          }, 300);
        }

      } else if (persons === 'person-1') {
        var product1 = '.ubed-m-300-enkel';
        var product2 = '.ubed-m-100-enkel';
        var mattress_size_person1 = $('[name="mattress_size_person1"]:checked').val().replace(/\n/g, '');
        var firmness_suits_person1 = $('[name="firmness_suits_person1"]:checked').val().replace(/\n/g, '');
        var firmness_suits = size[firmness_suits_person1];
        var qty = 1;
        var title, id1, id2, price1, price2;

        // Check if it's a double size for single person
        if (doubleSizesForSingle.includes(mattress_size_person1)) {
          // Use double mattress products for large sizes
          product1 = '.ubed-m-300-dubbel';
          product2 = '.ubed-m-100-dubbel';
          
          // Create double firmness title with dash format
          title = formatTwoPersonTitle(mattress_size_person1, firmness_suits, firmness_suits);
          
          id1 = getVariantId(product1, title);
          id2 = getVariantId(product2, title);
          price1 = getVariantPrice(product1, id1);
          price2 = getVariantPrice(product2, id2);
          
          $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_person_300']);
          $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_person_100']);
        } else {
          // Handle smaller sizes that need to be split into two singles
          if (mattress_size_person1 === '160x200') {
            qty = 2;
            mattress_size_person1 = '80x200';
          } else if (mattress_size_person1 == '160x210') {
            qty = 2;
            mattress_size_person1 = '80x210';
          } else if (mattress_size_person1 == '160x220') {
            qty = 2;
            mattress_size_person1 = '80x220';
          } else if (mattress_size_person1 == '180x200') {
            qty = 2;
            mattress_size_person1 = '90x200';
          } else if (mattress_size_person1 == '180x210') {
            qty = 2;
            mattress_size_person1 = '90x210';
          } else if (mattress_size_person1 == '180x220') {
            qty = 2;
            mattress_size_person1 = '90x220';
          }

          title = `${mattress_size_person1} / ${firmness_suits}`;
          id1 = getVariantId(product1, title);
          id2 = getVariantId(product2, title);

          if (qty === 2) {
            price1 = getVariantPrice(product1, id1, true);
            price2 = getVariantPrice(product2, id2, true);
            $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_single_person_300']);
            $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_single_person_100']);
          } else {
            price1 = getVariantPrice(product1, id1);
            price2 = getVariantPrice(product2, id2);
            $(`${product1} .quiz_prod_header img`).attr('src', product_images['single_person_300']);
            $(`${product2} .quiz_prod_header img`).attr('src', product_images['single_person_100']);
          }
        }

        if (setProductData(product1, id1, title, price1, qty) && setProductData(product2, id2, title, price2, qty)) {
          setTimeout(function() {
            $(product1).show();
            $(product2).show();
          }, 300);
        }

      } else if (persons === 'person-2') {
        var mattress_size_person2 = $('[name="mattress_size_person2"]:checked').val().replace(/\n/g, '');
        if (mattress_size_person2.includes('2x ')) {
          var product1 = '.ubed-m-300-enkel';
          var product2 = '.ubed-m-100-enkel';
          mattress_size_person2 = mattress_size_person2.replace('2x ', '');
          var qty = 2;
        } else {
          var product1 = '.ubed-m-300-dubbel';
          var product2 = '.ubed-m-100-dubbel';
          var qty = 1;
        }

        var firmness_suits1_person2 = $('[name="firmness_suits1_person2"]:checked').val().replace(/\n/g, '');
        var firmness_suits2_person2 = $('[name="firmness_suits2_person2"]:checked').val().replace(/\n/g, '');
        var firmness_suits1 = size[firmness_suits1_person2];
        var firmness_suits2 = size[firmness_suits2_person2];
        var title = formatTwoPersonTitle(mattress_size_person2, firmness_suits1, firmness_suits2);

        var id1, id2, price1, price2;

        if (qty === 2) {
          // Voor 2x enkele matrassen - ALTIJD 2 stuks toevoegen
          if (firmness_suits1 === firmness_suits2) {
            // Zelfde hardheid voor beide personen
            var titleMulti = `${mattress_size_person2} / ${firmness_suits1}`;
            id1 = getVariantId(product1, titleMulti);
            id2 = getVariantId(product2, titleMulti);
            price1 = getVariantPrice(product1, id1, true);
            price2 = getVariantPrice(product2, id2, true);
            
            setProductData(product1, id1, `${titleMulti} (2 stuks)`, price1, 2);
            setProductData(product2, id2, `${titleMulti} (2 stuks)`, price2, 2);
          } else {
            // Verschillende hardheden - instructie voor 2x toevoegen
            var titlePerson1 = `${mattress_size_person2} / ${firmness_suits1}`;
            id1 = getVariantId(product1, titlePerson1);
            id2 = getVariantId(product2, titlePerson1);
            price1 = getVariantPrice(product1, id1);
            price2 = getVariantPrice(product2, id2);
            
            setProductData(product1, id1, titlePerson1, price1, 1);
            setProductData(product2, id2, titlePerson1, price2, 1);
            
            $(`${product1} .prod_subtitle`).html(`
              <strong>${mattress_size_person2}</strong><br>
              <span style="color: #19747e;">✓ Persoon 1: ${firmness_suits1}</span><br>
              <span style="color: #19747e;">✓ Persoon 2: ${firmness_suits2}</span><br>
              <em style="color: #e74c3c; font-weight: bold;">Let op: Voeg dit product 2x toe:</em><br>
              <small>1. Eerst met ${firmness_suits1}<br>
              2. Dan wijzigen naar ${firmness_suits2} en nogmaals toevoegen</small>
            `);
            $(`${product2} .prod_subtitle`).html(`
              <strong>${mattress_size_person2}</strong><br>
              <span style="color: #19747e;">✓ Persoon 1: ${firmness_suits1}</span><br>
              <span style="color: #19747e;">✓ Persoon 2: ${firmness_suits2}</span><br>
              <em style="color: #e74c3c; font-weight: bold;">Let op: Voeg dit product 2x toe:</em><br>
              <small>1. Eerst met ${firmness_suits1}<br>
              2. Dan wijzigen naar ${firmness_suits2} en nogmaals toevoegen</small>
            `);
          }
          $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_single_person_300']);
          $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_single_person_100']);
        } else {
          id1 = getVariantId(product1, title);
          id2 = getVariantId(product2, title);
          price1 = getVariantPrice(product1, id1);
          price2 = getVariantPrice(product2, id2);
          
          setProductData(product1, id1, title, price1, 1);
          setProductData(product2, id2, title, price2, 1);
          
          $(`${product1} .quiz_prod_header img`).attr('src', product_images['two_person_300']);
          $(`${product2} .quiz_prod_header img`).attr('src', product_images['two_person_100']);
        }

        if (setProductData(product1, id1, title, price1, qty) && setProductData(product2, id2, title, price2, qty)) {
          setTimeout(function() {
            $(product1).show();
            $(product2).show();
          }, 300);
        }
      }
    }
  });

  // "Vorige" knop: navigatielogica en zet Next weer op disabled
  $('.prev-step').click(function() {
    var step = $('.MsForm_step.active').data('step') * 1;
    var nextStep = step - 1;
    var persons = $('[name="persons"]:checked').data('value');
    var maxStep = 5;
    if (persons === 'person-3') maxStep = 3;

    if (nextStep === maxStep) {
      $('.MsFormHeader_progress').addClass('success');
      var btn_text = $('.next-step').data('success');
      $('.next-step').text(btn_text);
    } else {
      var btn_text = $('.next-step').data('next');
      $('.next-step').text(btn_text);
      $('.MsFormHeader_progress').removeClass('success');
    }
    $('.maxCount').text(maxStep - 1);

    if (nextStep <= maxStep && nextStep > 0) {
      var bg = `conic-gradient(#111111 ${(nextStep / maxStep) * 360}deg, #d3d3d3 ${(nextStep / maxStep) * 360}deg 360deg)`;
      $('.MsProgress').css("background", bg);
      $('.MsProgress--value.not-success-text').text(`0${nextStep}`);
      $('.MsProgress--title .count').text(nextStep);
      var totalSteps = $('.MsForm_step').length;
      var percent = (nextStep / totalSteps) * 100;
      $('.custom-progress-bar').css('width', percent + '%');

      if (nextStep === 1) {
        $('.prev-step').hide();
        $('.content-person').show();
        $(`.content-${persons}`).hide();
      }
      $('.MsForm_step.active').removeClass('active');
      $(`.MsForm_step[data-step="${nextStep}"]`).addClass('active');
      
      // BELANGRIJK: Initialiseer calculator na terug navigeren
      setTimeout(initializeFirmnessCalculator, 200);
    }

    // Zet Next-knop weer op disabled
    $('.next-step').addClass('disabled');
  });

  // Eenvoudige change-listener: luister op elk change binnen de actieve stap
  $(document).on('change', '.MsForm_step.active input[type="radio"]', function() {
    var step = $('.MsForm_step.active').data('step') * 1;
    var persons = $('[name="persons"]:checked').data('value');

    // Bereken minimum benodigde keuzes per persona + stap
    var minChecked = 1;

    if (persons === 'person-2') {
      // 1–2: 1 keuze, 3–4: 2 keuzes
      if (step === 3 || step === 4) {
        minChecked = 2;
      }
    }
    // person-1 & person-3: altijd 1 keuze voor alle stappen

    var checkedCount = $('.MsForm_step.active input[type="radio"]:checked').length;
    if (checkedCount >= minChecked) {
      $('.next-step').removeClass('disabled');
    } else {
      $('.next-step').addClass('disabled');
    }
  });

  // Als persoon verandert: reset keuzes, progress en zet Next op disabled
  $('[name="persons"]').change(function() {
    $('.MsForm_step input[type="radio"]').each(function() {
      if ($(this).attr('name') !== 'persons') {
        $(this).prop('checked', false);
      }
    });

    var persons = $(this).data('value');
    var nextStep = 1;
    var maxStep = 5;
    if (persons === 'person-3') maxStep = 3;

    var bg = `conic-gradient(#111111 ${(nextStep / maxStep) * 360}deg, #d3d3d3 ${(nextStep / maxStep) * 360}deg 360deg)`;
    $('.MsProgress').css("background", bg);
    $('.MsProgress--title .count').text(nextStep);
    var totalSteps = $('.MsForm_step').length;
    var percent = (nextStep / totalSteps) * 100;
    $('.custom-progress-bar').css('width', percent + '%');

    $('.MsProgress--title .maxCount').text(maxStep - 1);

    // Zet Next in stap 1 weer op disabled totdat de gebruiker een keuze maakt
    $('.next-step').addClass('disabled');
  });

  // Init: Next disabled, Prev verborgen
  $('.next-step').addClass('disabled');
  $('.prev-step').hide();
});

// Rest van de code blijft hetzelfde...
// (Retake button, firmness popup, firmness parameters, etc.)

// Retake-knop: reset alles en zet Next opnieuw op disabled
$('.retake_quiz_btn').click(function() {
  removeQueryString();
  $('.MsForm_step input').each(function() {
    $(this).prop('checked', false);
  });
  $('.quiz_result_main').hide();
  $('.multistepForm_section').removeClass('hide');

  var nextStep = 1;
  var maxStep = 5;
  var bg = `conic-gradient(#111111 ${(nextStep / maxStep) * 360}deg, #d3d3d3 ${(nextStep / maxStep) * 360}deg 360deg)`;
  $('.MsProgress').css("background", bg);
  $('.MsProgress--value.not-success-text').text(`0${nextStep}`);
  $('.MsProgress--title .count').text(nextStep);
  var totalSteps = $('.MsForm_step').length;
  var percent = (nextStep / totalSteps) * 100;
  $('.custom-progress-bar').css('width', percent + '%');

  $('.MsForm_step.active').removeClass('active');
  $(`.MsForm_step[data-step="${nextStep}"]`).addClass('active');
  $('.MsFormHeader_progress').removeClass('success');
  var btn_text = $('.next-step').data('next');
  $('.next-step').text(btn_text);
  $('.next-step').addClass('disabled');
  $('.prev-step').hide();
});

// Firmness-popup logic
const firmBtns = document.querySelectorAll('.firmness-popup-inner');
firmBtns.forEach(function(btn) {
  btn.addEventListener("click", function() {
    document.querySelector('.firmness_info_popup').classList.toggle("active");
  });
});

// Firmness parameters
let firmness_parameters = {
  "back":  [18.25, 21.50, 26.50],
  "belly": [18.25, 21.50, 26.50],
  "side":  [19.25, 23.25, 29.00],
  "":      [19.25, 23.25, 29.00],
};

let firmness_values = [
  'zacht',
  'medium',
  'stevig',
  'extra stevig',
];

// Controleer of ingevoerde tekens geldig zijn (numbers-only)
function check_number(event) {
  var key = event.keyCode || event.charCode;
  if (isFinite(event.key)) {
    if (event.target.value.length > 2) {
      event.preventDefault();
    }
  } else if (![8, 9, 35, 36, 37, 38, 39, 40, 46].includes(key)) {
    event.preventDefault();
  }
}

// Zet focus op een ongeldig veld
function set_focus(input) {
  if (!input.value || !input.checkValidity()) {
    input.focus();
    return true;
  }
  return false;
}

// Als formulier niet de focus heeft, zet focus op eerste input
function set_focus_form(form) {
  if (!form.contains(document.activeElement)) {
    set_focus(form['length']) || set_focus(form['weight']);
  }
}

// Bereken firmness op basis van lengte, gewicht en positie
function calculate_firmness(event = null, change = false, form) {
  let length = parseInt(form['length'].value);
  let weight = parseInt(form['weight'].value);
  let sleeping_position = form['sleeping-position'].value;

  let length_is_valid = length && length >= form['length'].min && length <= form['length'].max;
  let weight_is_valid = weight && weight >= form['weight'].min && weight <= form['weight'].max;

  var firmness = "";
  if (length_is_valid && weight_is_valid) {
    let bmi = 10000 * weight / length / length;
    let score = 0;
    for (let value of firmness_parameters[sleeping_position]) {
      if (bmi > value) {
        score += 1;
      }
    }
    firmness = firmness_values[score];
  }

  // Update recommendation input in the current form
  form['recommendation'].value = firmness;

  // Update all elements with class 'recommendation'
  var inputs = form.querySelectorAll('.recommendation');
  inputs.forEach(function(input) {
    input.value = firmness;
  });

  if (event) {
    let input = event.target;
    if (change || input.value.length > 2) {
      input.setAttribute('aria-invalid', !input.reportValidity());
    }
  }
}

// Voeg event listeners toe aan alle firmness-calculator-formulieren
document.querySelectorAll('.firmness-calculator').forEach(function(form) {
  form.addEventListener('input', function(event) {
    calculate_firmness(event, false, form);
  });

  form.addEventListener('change', function(event) {
    calculate_firmness(event, true, form);
  });

  form['length'].addEventListener('keypress', check_number);
  form['weight'].addEventListener('keypress', check_number);

  // Zet initiële focus als dat nodig is
  set_focus_form(form);
});

$(document).on('click', '.discover_btn', function() {
  saveCheckedInputs();
});

// Na het tonen van de resultaten, scroll ernaartoe
function scrollToResult() {
  var resultEl = document.querySelector('.quiz_result_main');
  if (resultEl) {
    resultEl.scrollIntoView({ behavior: 'smooth' });
  }
}

document.addEventListener('click', function(e) {
  if (e.target.matches('.view-results')) {
    setTimeout(scrollToResult, 300);
  }
});

// NIEUW: Event listener voor "Laat resultaten zien" button
$(document).on('click', '.next-step', function(e) {
  // Als we in de laatste stap zijn en op "Toon resultaten" klikken
  var step = $('.MsForm_step.active').data('step') * 1;
  var persons = $('[name="persons"]:checked').data('value');
  var maxStep = 5;
  if (persons === 'person-3') maxStep = 3;
  
  if (step === maxStep && $(this).text().toLowerCase().includes('resultaten')) {
    // Sla de gecontroleerde inputs op
    saveCheckedInputs();
    // Voeg query string toe
    addQueryString();
  }
});

// NIEUW: Event listener voor directe "Laat resultaten zien" button (indien aanwezig)
$(document).on('click', '.show-results-btn, .view-results-btn, [data-action="show-results"]', function(e) {
  e.preventDefault();
  saveCheckedInputs();
  addQueryString();
  checkQueryString();
});

// EENVOUDIGE OPLOSSING: Laat Shopify's eigen cart system het volledig afhandelen
$(document).on('click', '.quiz_prod_btns button[type="submit"]', function(e) {
  // NIET preventDefault() - laat Shopify's native form submission werken
  
  var button = $(this);
  var form = button.closest('form');
  var productWrap = button.closest('.quiz_prod_wrap');
  
  console.log('Cart button clicked - letting Shopify handle it');
  
  // Zorg dat het juiste variant ID in de form staat voordat Shopify het afhandelt
  var selectElement = productWrap.find('select.product_variants');
  var selectedVariantId = selectElement.val();
  
  console.log('Selected variant ID from select:', selectedVariantId);
  
  // Update het hidden input veld met de geselecteerde variant
  var hiddenIdInput = form.find('input[name="id"]');
  if (hiddenIdInput.length > 0 && selectedVariantId) {
    console.log('Updating hidden input from', hiddenIdInput.val(), 'to', selectedVariantId);
    hiddenIdInput.val(selectedVariantId);
  }
  
  // Update quantity van .quantity element naar form
  var quantityFromElement = productWrap.find('.quantity').val();
  var quantityInput = form.find('input[name="quantity"]');
  
  if (quantityFromElement && quantityInput.length > 0) {
    console.log('Updating quantity to:', quantityFromElement);
    quantityInput.val(quantityFromElement);
  }
  
  // Laat Shopify's eigen form submission het verder afhandelen
  console.log('Final form data before Shopify submission:');
  console.log('- Variant ID:', form.find('input[name="id"]').val());
  console.log('- Quantity:', form.find('input[name="quantity"]').val() || 1);
  console.log('- Form action:', form.attr('action'));
  
  // Toon loading state
  button.prop('disabled', true).text('Toevoegen...');
  
  // Geen e.preventDefault() - laat de native form submission doorgaan
});